export default __webpack_public_path__ + "5549e25.png";